import "./internal.js";
// import VideoResources from "./lib/VideoResources.js";
import MobileNav from "./lib/MobileNav.js";
import './lib/video-resources.js';

document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new MobileNav('mobileNavButton', 'mobileNav');
	// new VideoResources();
});

